import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { AuditContextList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { AuditContextCreateInitializer } from "./create/initializer";
import { AuditContextDetailInitializer } from "./detailInitializer";

const AuditContextRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<AuditContextList />} />
        <Route path={`-create/*`} element={<AuditContextCreateInitializer />} />
        <Route path={`:auditctx/*`} element={<AuditContextDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default AuditContextRoute;
